fragment TagFragment on Tag {
    id
    name
    color
    creator {
        id
        name
    }
    createdTime
}
